namespace TabAurous.Finance {
    export interface PartyBalanceRow {
        PartyBalanceId?: number;
        TransId?: number;
        RefTransId?: number;
        TransDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        VoucherNo?: string;
        AgainstVoucherTypeId?: number;
        AgainstVoucherNo?: string;
        InvoiceNo?: string;
        AgainstInvoiceNo?: string;
        ReferenceType?: string;
        Debit?: number;
        Credit?: number;
        CCDebit?: number;
        CCCredit?: number;
        Due?: number;
        KnockOff?: number;
        MDebit?: number;
        MCredit?: number;
        CreditPeriod?: number;
        ExchangeRate?: number;
        FinancialYearId?: number;
        CompanyId?: number;
        POSCustomerId?: number;
        TotalAmount?: number;
        ReceivedAmount?: number;
        BalanceAmount?: number;
        CreditNote?: number;
        DebitNote?: number;
        OverDueDays?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
        CheckRefund?: boolean;
    }

    export namespace PartyBalanceRow {
        export const idProperty = 'PartyBalanceId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PartyBalance';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            PartyBalanceId = "PartyBalanceId",
            TransId = "TransId",
            RefTransId = "RefTransId",
            TransDate = "TransDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            VoucherNo = "VoucherNo",
            AgainstVoucherTypeId = "AgainstVoucherTypeId",
            AgainstVoucherNo = "AgainstVoucherNo",
            InvoiceNo = "InvoiceNo",
            AgainstInvoiceNo = "AgainstInvoiceNo",
            ReferenceType = "ReferenceType",
            Debit = "Debit",
            Credit = "Credit",
            CCDebit = "CCDebit",
            CCCredit = "CCCredit",
            Due = "Due",
            KnockOff = "KnockOff",
            MDebit = "MDebit",
            MCredit = "MCredit",
            CreditPeriod = "CreditPeriod",
            ExchangeRate = "ExchangeRate",
            FinancialYearId = "FinancialYearId",
            CompanyId = "CompanyId",
            POSCustomerId = "POSCustomerId",
            TotalAmount = "TotalAmount",
            ReceivedAmount = "ReceivedAmount",
            BalanceAmount = "BalanceAmount",
            CreditNote = "CreditNote",
            DebitNote = "DebitNote",
            OverDueDays = "OverDueDays",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate",
            CheckRefund = "CheckRefund"
        }
    }
}
